import { Box, Container, Flex, retriever } from '@retriever-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CustomButton } from 'src/components/button'

import BrandsOnPhone from '../../appspace/brands-on-phone-animation'

const Ecosystem = () => {
  const { t } = useTranslation('landing-pages/growth')

  return (
    <Flex
      direction={['column', 'row']}
      background="primary.500"
      pY={['60px', '80px']}
      pBottom="40px"
    >
      <Container
        flexDirection={['column', 'row']}
        alignItems="center"
        justifyContent="space-between"
        gap={['60px', '80px']}
        paddingX={[0, '100px']}
      >
        <Flex direction="column" gap="24px" width={['100%', '450px']}>
          <retriever.p fontSize="32px" fontWeight="bold" color="black.0">
            {t('landing-pages/growth:ecosystem.TITLE')}
          </retriever.p>
          <retriever.p color="black.0" fontSize="16px" fontWeight="bold">
            {t('landing-pages/growth:ecosystem.CALL')}
          </retriever.p>
          <retriever.p
            color="black.0"
            fontSize="16px"
            lineHeight="24px"
            width={['100%', '500px']}
          >
            {t('landing-pages/growth:ecosystem.TEXT')}
          </retriever.p>
          <a href="https://appspace.housi.com/sindicos" target="_blank">
            <CustomButton
              rounded
              buttonTheme="white"
              style={{ color: 'white' }}
            >
              Saiba mais
            </CustomButton>
          </a>
        </Flex>
        <Box>
          <BrandsOnPhone />
        </Box>
      </Container>
    </Flex>
  )
}

export default Ecosystem
